import { render, staticRenderFns } from "./invoiceDemo.vue?vue&type=template&id=4b51e1c8&scoped=true&"
import script from "./invoiceDemo.vue?vue&type=script&lang=js&"
export * from "./invoiceDemo.vue?vue&type=script&lang=js&"
import style0 from "./invoiceDemo.vue?vue&type=style&index=0&id=4b51e1c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51e1c8",
  null
  
)

export default component.exports